import { api } from './apiClient';

/**
 * Time & Payroll command-room client. Aggregates the existing attendance /
 * leave / payroll core (migration 015) + payroll-plus (063) into control-tower
 * views: a Time & Payroll Command Center, a Payroll Run cockpit (with the
 * real payroll -> GL posting surfaced), an Attendance Control Center and a
 * Leave Control Center. Every figure is real SQL over existing tables; no new
 * schema. apiClient auto-unwraps {status,data}.
 *
 * The GL-posting call reuses the already-shipped hr-payroll-plus poster
 * (hrPostingService) rather than duplicating it.
 */
export const hrTimePayrollService = {
  // ---- Command center ----
  commandCenter: (): Promise<any> => api.get('/hr-time-payroll/command-center'),

  // ---- Payroll run cockpit ----
  runWorkspace: (id: number): Promise<any> => api.get(`/hr-time-payroll/payroll-runs/${id}/workspace`),
  /** Post a processed run to the GL as one balanced salary journal. Idempotent. */
  postPayrollRun: (id: number): Promise<any> => api.post(`/hr-payroll-plus/payroll-runs/${id}/post`, {}),

  // ---- Attendance control center ----
  attendanceBoard: (date?: string): Promise<any> =>
    api.get('/hr-time-payroll/attendance/board', { params: date ? { date } : {} }),
  attendanceMatrix: (params: { month: number; year: number; departmentId?: number }): Promise<any> =>
    api.get('/hr-time-payroll/attendance/matrix', { params }),
  attendanceTrend: (days = 30): Promise<any> =>
    api.get('/hr-time-payroll/attendance/trend', { params: { days } }),

  // ---- Leave control center ----
  leaveDashboard: (): Promise<any> => api.get('/hr-time-payroll/leave/dashboard'),
  leaveCalendar: (params: { month: number; year: number }): Promise<any> =>
    api.get('/hr-time-payroll/leave/calendar', { params }),
  leaveLiability: (): Promise<any> => api.get('/hr-time-payroll/leave/liability'),
};

export default hrTimePayrollService;
